import { REGEX_PROTOCOL, REGEX_TRAILING_SLASH } from 'constants/regex';

export const removeHTTPFromURL = (url: string) =>
  url.replace(REGEX_PROTOCOL, '').replace(REGEX_TRAILING_SLASH, '');
